// // src/components/common/FormField.jsx
// import React, { useRef } from 'react';
// import { cn } from '../../lib/utils';
// import { Label } from '../ui/label';
// import { Input } from '../ui/input';
// import { Textarea } from '../ui/textarea';
// import { Switch } from '../ui/switch';
// import {
//   Select,
//   SelectContent,
//   SelectItem,
//   SelectTrigger,
//   SelectValue,
// } from '../ui/select';
// import { Calendar, Clock } from 'lucide-react'; // Add these icons

// const FormField = ({
//   label,
//   name,
//   type = 'text',
//   value,
//   checked,
//   onChange,
//   onCheckedChange,
//   error,
//   required = false,
//   placeholder,
//   options = [],
//   className,
//   disabled = false,
//   step,
//   ...props
// }) => {
//   const inputRef = useRef(null);

//   // Opens native date/time picker instantly (modern browsers)
//   const openPicker = () => {
//     if (!inputRef.current) return;

//     inputRef.current.focus();

//     // Modern browsers (Chrome, Edge, Safari 15.4+) support showPicker()
//     if ('showPicker' in inputRef.current) {
//       try {
//         (inputRef.current).showPicker();
//       } catch (err) {
//         // Some browsers throw if already open → safe to ignore
//       }
//     } else {
//       // Fallback: simulate click (works in older Chrome/Firefox)
//       inputRef.current.click();
//     }
//   };

//   const renderField = () => {
//     switch (type) {
//       case 'textarea':
//         return (
//           <Textarea
//             id={name}
//             name={name}
//             value={value}
//             onChange={onChange}
//             placeholder={placeholder}
//             className={cn(error && 'border-destructive focus-visible:ring-destructive', className)}
//             disabled={disabled}
//             {...props}
//           />
//         );

//       case 'select':
//         return (
//           <Select
//             value={value}
//             onValueChange={(val) => onChange?.({ target: { name, value: val } })}
//             disabled={disabled}
//           >
//             <SelectTrigger className={cn(error && 'border-destructive', className)}>
//               <SelectValue placeholder={placeholder || `Select ${label}`} />
//             </SelectTrigger>
//             <SelectContent>
//               {options.map((option) => (
//                 <SelectItem key={option.value} value={option.value}>
//                   {option.label}
//                 </SelectItem>
//               ))}
//             </SelectContent>
//           </Select>
//         );

//       case 'switch':
//         return (
//           <div className="flex items-center space-x-2">
//             <Switch
//               id={name}
//               checked={checked}
//               onCheckedChange={(checked) => {
//                 onCheckedChange?.(checked);
//                 onChange?.({ target: { name, value: checked } });
//               }}
//               disabled={disabled}
//             />
//             {label && (
//               <Label htmlFor={name} className="cursor-pointer">
//                 {label}
//                 {required && <span className="text-destructive ml-1">*</span>}
//               </Label>
//             )}
//           </div>
//         );

//       case 'checkbox':
//         return (
//           <div className="flex items-center space-x-2">
//             <input
//               type="checkbox"
//               id={name}
//               name={name}
//               checked={checked}
//               onChange={(e) => {
//                 const checked = e.target.checked;
//                 onCheckedChange?.(checked);
//                 onChange?.({ target: { name, value: checked } });
//               }}
//               className={cn('h-4 w-4 rounded border-gray-300', disabled && 'cursor-not-allowed opacity-50')}
//               disabled={disabled}
//             />
//             {label && (
//               <Label htmlFor={name} className="cursor-pointer">
//                 {label}
//                 {required && <span className="text-destructive ml-1">*</span>}
//               </Label>
//             )}
//           </div>
//         );

//       // Enhanced Input for date/time with instant picker
//       default:
//         return (
//           <div className="relative">
//             <Input
//               ref={inputRef}
//               id={name}
//               name={name}
//               type={type}
//               value={value || ''}
//               onChange={onChange}
//               placeholder={placeholder}
//               step={step}
//               disabled={disabled}
//               className={cn(
//                 'transition-all',
//                 error && 'border-destructive focus-visible:ring-destructive',
//                 (type === 'date' || type === 'time') && 'pr-10 cursor-pointer',
//                 className
//               )}
//               {...props}
//             />

//             {/* Calendar / Clock Icon for date/time fields */}
//             {(type === 'date' || type === 'time') && (
//               <div
//                 className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
//                 onClick={(e) => {
//                   e.preventDefault();
//                   openPicker();
//                 }}
//               >
//                 {type === 'date' ? (
//                   <Calendar className="h-4 w-4 text-muted-foreground" />
//                 ) : (
//                   <Clock className="h-4 w-4 text-muted-foreground" />
//                 )}
//               </div>
//             )}
//           </div>
//         );
//     }
//   };

//   // Special rendering for switch/checkbox
//   if (type === 'switch' || type === 'checkbox') {
//     return (
//       <div className="space-y-2">
//         {renderField()}
//         {error && <p className="text-sm text-destructive">{error}</p>}
//       </div>
//     );
//   }

//   return (
//     <div className="space-y-2">
//       {label && type !== 'switch' && type !== 'checkbox' && (
//         <Label
//           htmlFor={name}
//           className={cn(
//             'cursor-pointer',
//             (type === 'date' || type === 'time') && 'select-none'
//           )}
//           onClick={(e) => {
//             // Prevent double trigger when clicking label
//             e.preventDefault();
//             if (type === 'date' || type === 'time') {
//               openPicker();
//             }
//           }}
//         >
//           {label}
//           {required && <span className="text-destructive ml-1">*</span>}
//         </Label>
//       )}

//       {/* Clickable wrapper for date/time fields */}
//       {(type === 'date' || type === 'time') ? (
//         <div
//           className="cursor-pointer rounded-md transition-all hover:ring-2 hover:ring-primary/20 focus-within:ring-2 focus-within:ring-primary/30"
//           onClick={(e) => {
//             e.preventDefault();
//             openPicker();
//           }}
//         >
//           {renderField()}
//         </div>
//       ) : (
//         renderField()
//       )}

//       {error && <p className="text-sm text-destructive">{error}</p>}
//     </div>
//   );
// };

// export default FormField;


// src/components/common/FormField.jsx
import React, { useEffect, useRef, useState, forwardRef } from 'react';
import { cn } from '../../lib/utils';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { Switch } from '../ui/switch';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from '../ui/command';
import { Check, ChevronsUpDown, Calendar, Clock, X } from 'lucide-react';

// ────────────────────────────── SEARCHABLE SELECT (JS version) ──────────────────────────────
const SearchableSelect = forwardRef(function SearchableSelect(props, ref) {
  const {
    value = '',
    onValueChange,
    placeholder = 'Select...',
    options = [],
    disabled = false,
    className,
    error = false,
  } = props;

  const [open, setOpen] = useState(false);
  const containerRef = useRef(null); // ← to detect outside clicks

  const display = options.find((o) => o.value === value)?.label || placeholder;

  // Close when clicking outside
  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const handleEscape = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [open]);

  return (
    <div ref={containerRef} className="relative">
      <button
        ref={ref}
        type="button"
        disabled={disabled}
        onClick={() => !disabled && setOpen(!open)}
        className={cn(
          'flex h-10 w-full items-center justify-between rounded-md border bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          error && 'border-destructive focus:ring-destructive',
          className
        )}
      >
        <span className={value ? '' : 'text-muted-foreground'}>{display}</span>
        <ChevronsUpDown className="h-4 w-4 opacity-50 shrink-0" />
      </button>

      {open && (
        <div className="absolute z-50 mt-1 w-full rounded-md border bg-popover text-popover-foreground shadow-md">
          <Command>
            <CommandInput
              placeholder={`Search ${placeholder.toLowerCase()}...`}
              autoFocus
            />
            <CommandList>
              <CommandEmpty>No results found.</CommandEmpty>
              <CommandGroup>
                {options.map((opt) => (
                  <CommandItem
                    key={opt.value}
                    value={opt.label} // ← search by label
                    onSelect={() => {
                      const newVal = value === opt.value ? '' : opt.value;
                      onValueChange(newVal);
                      setOpen(false); // ← close after selection
                    }}
                  >
                    <Check
                      className={cn(
                        'mr-2 h-4 w-4',
                        value === opt.value ? 'opacity-100' : 'opacity-0'
                      )}
                    />
                    {opt.label}
                  </CommandItem>
                ))}
              </CommandGroup>
            </CommandList>
          </Command>
        </div>
      )}
    </div>
  );
});

// ───────────────────────────────────── MAIN FORM FIELD COMPONENT ─────────────────────────────────────
const FormField = ({
  label,
  name,
  type = 'text',
  value,
  checked,
  onChange,
  onCheckedChange,
  error,
  required = false,
  placeholder,
  options = [],
  className,
  disabled = false,
  step,
  searchable = true, // ← searchable by default everywhere
  ...props
}) => {
  const inputRef = useRef(null);

  const openPicker = () => {
    if (!inputRef.current) return;
    inputRef.current.focus();
    if ('showPicker' in inputRef.current) {
      try {
        inputRef.current.showPicker();
      } catch (e) {
        // ignore – some browsers throw when already open
      }
    }
  };

  const renderField = () => {
    switch (type) {
      case 'textarea':
        return (
          <Textarea
            id={name}
            name={name}
            value={value || ''}
            onChange={onChange}
            placeholder={placeholder}
            disabled={disabled}
            className={cn(
              error && 'border-destructive focus-visible:ring-destructive',
              className
            )}
            {...props}
          />
        );

      case 'select':
        if (searchable) {
          return (
            <SearchableSelect
              value={value || ''}
              onValueChange={(val) =>
                onChange && onChange({ target: { name, value: val } })
              }
              placeholder={placeholder || label || 'Select...'}
              options={options}
              disabled={disabled}
              className={className}
              error={!!error}
            />
          );
        }

        // fallback non-searchable select
        return (
          <Select
            value={value}
            onValueChange={(val) =>
              onChange && onChange({ target: { name, value: val } })
            }
            disabled={disabled}
          >
            <SelectTrigger className={cn(error && 'border-destructive', className)}>
              <SelectValue placeholder={placeholder || `Select ${label}`} />
            </SelectTrigger>
            <SelectContent>
              {options.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>
                  {opt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        );

      case 'switch':
        return (
          <div className="flex items-center space-x-2">
            <Switch
              id={name}
              checked={checked}
              onCheckedChange={(c) => {
                onCheckedChange && onCheckedChange(c);
                onChange && onChange({ target: { name, value: c } });
              }}
              disabled={disabled}
            />
            {label && (
              <Label htmlFor={name} className="cursor-pointer">
                {label}
                {required && <span className="text-destructive ml-1">*</span>}
              </Label>
            )}
          </div>
        );

    default:
  return (
    <div className="relative">
      <Input
        ref={inputRef}
        id={name}
        name={name}
        type={type}
        value={value ?? ''}  // Use nullish coalescing
        onChange={onChange}
        placeholder={placeholder}
        step={step}
        disabled={disabled}
        className={cn(
          error && 'border-destructive focus-visible:ring-destructive',
          (type === 'date' || type === 'time') && 'pr-10',
          className
        )}
        {...props}
      />
      {(type === 'date' || type === 'time') && (
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            if (value) {
              // Clear the field
              onChange({ target: { name, value: "", type } });
            } else {
              openPicker();
            }
          }}
          className="absolute inset-y-0 right-0 flex items-center pr-3 hover:opacity-70"
        >
          {value ? (
            <X className="h-4 w-4 text-muted-foreground" />
          ) : type === 'date' ? (
            <Calendar className="h-4 w-4 text-muted-foreground" />
          ) : (
            <Clock className="h-4 w-4 text-muted-foreground" />
          )}
        </button>
      )}
    </div>
  );
    }
  };

  // switch has label inside
  if (type === 'switch') {
    return (
      <div className="space-y-2">
        {renderField()}
        {error && <p className="text-sm text-destructive">{error}</p>}
      </div>
    );
  }

  return (
    <div className="space-y-2">
      {label && type !== 'switch' && (
        <Label
          htmlFor={name}
          className={cn(
            'cursor-pointer',
            (type === 'date' || type === 'time') && 'select-none'
          )}
          onClick={(e) => {
            e.preventDefault();
            if (type === 'date' || type === 'time') openPicker();
          }}
        >
          {label}
          {required && <span className="text-destructive ml-1">*</span>}
        </Label>
      )}

      {(type === 'date' || type === 'time') ? (
        <div
          className="cursor-pointer"
          onClick={(e) => {
            e.preventDefault();
            openPicker();
          }}
        >
          {renderField()}
        </div>
      ) : (
        renderField()
      )}

      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
};

export default FormField;